import type { UserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { validateEmail } from '/@/utils';

export const validateGrowerEmail = (
    email: string,
    allGrowers: UserNode[],
    rvUserQuery?: UserNode,
    index?: number,
    formGrowers?: { email: string }[],
    currentGrowerNodeId?: number
) => {
    const normalizedEmail = email.trim().toLowerCase();

    if (formGrowers && formGrowers.length > 1) {
        const duplicateInForm = formGrowers.some(
            (grower, idx) =>
                idx !== index && grower.email?.trim().toLowerCase() === normalizedEmail && normalizedEmail !== ''
        );
        if (duplicateInForm) {
            return _('Ya cargaste a este productor en el formulario');
        }
    }

    if (normalizedEmail === rvUserQuery?.email?.toLowerCase())
        return _('El email del productor no puede ser el mismo que el de tu usuario');
    const existingGrower = allGrowers.find(
        (grower) =>
            grower.id !== currentGrowerNodeId &&
            [grower.email?.toLowerCase(), grower.user?.email?.toLowerCase()].includes(normalizedEmail)
    );
    if (existingGrower) {
        return _('Ya registraste a este productor');
    }
    return validateEmail(email);
};
